module.exports = __webpack_public_path__ + "static/media/wheels-1.81c2bc5e.png";